// 门店商品分类列表 https://yapi.sankuai.com/project/30178/interface/api/1088833

import { IDynamicTagGroup } from '@/src/components/DynamicTag';
import { SameShopSpuData } from '@/components/MultiSkuModalGolden/Components/MultiSpuLandscapeListView/types';
import { ShopDetailInfo } from '@/src/pages/shop/shop_detail/constants';
import { LX_REPORT_PRODUCT_CARD_TYPE, UserGetMode } from './utils/constant';
// import ListAdapter from "./foodList/adapter";

export interface Price {
  amount: number;
  currency: string;
  displayAmount: string;
  displayText: string;
}

export interface Sku {
  skuId: number;
  skuSpec: string;
  description?: any;
  pictures?: any;
  price?: Price;
  originPrice: Price;
  discountPrice: Price;
  promotionTags: PromotionTags[]; // 动态标签
  activityInfoList: ActivityInfoItem[]; // 活动信息
  calorie: string;
  groupList: GoodDetailGroupList[];
  extraInfo: GoodDetailSkuExtraInfo;
  fullDiscountExtraInfo: FullDiscountExtraInfo;
  discountPriceList: DiscountPriceItem[];
}

export interface DiscountPriceListItem {
  discountPrice: Price;
  promotionTags?: PromotionTags[]; // 动态标签
  promotionTagInfo?: {
    discountTag?: PromotionTag;
    windowDiscountTag?: PromotionTag;
    discountTypeTag?: PromotionTag;
  };

}

export interface SpuExtraInfo {
  expInfoList: ExpInfo[];
  /** 满折的优惠价格的字体颜色 */
  discountPriceColor: string;
  /** 满折的优惠价格的背景颜色 */
  discountPriceBackground: string;
  /** 主题色 */
  themeColor: string;
  /** 主题背景色 */
  backgroundColor: string;
  /** 折扣图案 */
  discountProductIcon: string;
}

export interface NoSingleInfo {
  noSingle: number; // 1：是单点不送商品 0：不是单点不送商品
  noSingleText: string;
  noSingleToast: string;
}
export interface Spu {
  spuId: number;
  name: string;
  description: string;
  calorie: string; // 卡路里信息
  salesList: SalesInfo[]; //销量信息
  customizableText: string; // 菜品是否可定制，1个以上主规格或有选项组
  pictures: string[];
  /** 取当前spu选中的sku下的 原价+默认groupSku选项 的最低价 */
  minPrice: Price;
  originPrice?: Price;
  discountPrice: Price;
  discountPriceList?: DiscountPriceListItem[];
  status?: any;
  skuList: Sku[];
  availableStatus: number;
  recommendInfoList?: RecommendInfo[];
  index: number; //初始化index，用于埋点
  tab_index: number; //用于埋点
  tab_name: string; //用于埋点参数绑定
  tab_type: string; //用于埋点
  tab_id: number; //用于埋点 即菜品分类id
  haveMultiSpecs?: number; // 是否有多个可选规格 1-是 0-否
  /** [查看暂不供应商品]列表有下架商品时展示此按钮 */
  showSectionFooterFold?: boolean; // 当成一个item展示，解决列表没有item时，锚点失效的问题
  promotionTags: PromotionTags[]; // 动态标签
  activityInfoList: ActivityInfoItem[]; // 活动信息
  spuType?: number; // 1 推荐菜  2 折扣菜 3 融合菜（是折扣菜也是推荐菜）
  recommendFoodLabel?: string; // 推荐菜的标签
  styleType?: number; // 0默认，单列 1 双列
  availableTime?: string; // 可售时间
  availableTimeText?: string; // 可售时间描述
  availableTimeTip?: AvailableTimeTip; // 可售时间弹窗数据
  is_last_spu: boolean; // 是否是当前分类的最后一个spu
  logData: SpuLogData; // spu埋点数据
  picturesForSpec?: string[]; // 规格图片
  extraInfo?: SpuExtraInfo;
  search_keyword?: string; // 用于搜索埋点
  card_type?: LX_REPORT_PRODUCT_CARD_TYPE; // 用于埋点上报，区分商品卡片来源
  noSingleInfo?: NoSingleInfo;
  promotionTagInfo?: {
    discountTag?: PromotionTag;
    windowDiscountTag?: PromotionTag;
    discountTypeTag?: PromotionTag;
  };
  productTagInfo?: {
    saleCountTag?: SalesTag; // 月销数量标签
    saleRankTag?: SalesTag[]; // 销量排行标签 单次最多下发2个（API控制）
    windowDiningCountTag?: DiningCount; //商品橱窗用餐人数标识
    cardDiningCountTag?: DiningCount; //商卡用餐人数标识
  };
}

export interface PromotionTag {
  text?: string;
  color?: string;
  icon?: string;
  bgColor?: string;
}

export interface SalesTag {
  text: string;
  icon?: string;
  color: string;
  extraInfo: {
    salesType: string;
  };
}

export interface DiningCount {
  text?: string;
  icon?: string;
}

export interface cardTagInfo {
  text: string;
  icon?: string;
  type?: string;
}

export interface SpuLogData {
  hasShopNewUserDiscountFood: number;
}

export interface AvailableTimeTip {
  title: string;
  details: AvailableTimeItem[];
}
export interface SalesInfo {
  salesType: string;
  content: string;
  type: number;
}

export interface AvailableTimeItem {
  days: string;
  timeRanges: string;
}

export interface ActivityInfoItem {
  priceInfo: Price;
  activityType: number;
  amount: number;
  currency: string;
  extraInfo: ActivityExtraInfo;
}
export interface RecommendInfo {
  recommendType: string;
  picture: string;
  content: string;
  fontColor?: string;
  bgImage?: string;
}

export interface ExtraInfo {
  /** 菜品分类tab字体颜色 */
  color: string;
  /** 菜品分类tab是否默认加粗 */
  bold: number;
}

export interface Category {
  shopCategoryId: number;
  shopCategoryType: number;
  shopCategoryName: string;
  /** 菜品分类tab类型，推荐商品-recommend，优惠商品-discount，物理菜单-normal */
  categoryItemType: string;
  /** 折扣菜tab icon */
  shopCategoryIcon: string;
  description: string;
  spuCount: number;
  status: number;
  spuList: Spu[];
  spuIdList: number[];
  foldSpuIdList?: number[]; // 折叠商品spuid
  shopCategoryDescription: string;
  styleType: number; // 0默认，单列 1 双列
  shopCategorySubtitle: string; // 门店分类子标题
  extraInfo?: ExtraInfo;
  categoryFoldInfo?: categoryFoldInfo; //折叠商品列表 包含折叠文案及折叠商品spuId
}

// 折叠商品信息
export interface categoryFoldInfo {
  foldStatusText?: string;
  spuFoldInfoList?: SpuFoldInfoList[];
}

// 折叠spuIdList
export interface SpuFoldInfoList {
  spuId: number;
}

export interface ProductListConfig {
  loadSize: number;
}

export interface ProductAnchorInfo {
  anchorCategoryId?: number;
}

export interface ShopWarnInfo {
  warnIcon: string;
  warnText: string;
  warnType: string;
  icon: string;
  color: string;
  backgroundColor: string;
}

export interface shopFeatureItem {
  style: number; // 0 默认普通图片 1 动态标签
  type: number; // 1 门店标签, 2营销系标签
  picInfo?: {
    picUrl: string; // 标签图片展示
    width: number; // 标签宽度
    height: number; // 标签高度
  };
  labelName: string; // 标签名称 埋点用
  tag?: any;
}
// 门店信息  https://yapi.sankuai.com/project/30178/interface/api/1091953
export interface ShopInfo {
  shopId: string;
  shopLogoUrl?: string;
  shopLabelList?: ShopLabel[];
  shopLabelListV2?: ShopLabel[];
  name: string;
  status: number;
  minCostPrice: Price;
  avgCostPriceDesc: string; //人均价描述
  primaryCategoryName: string;
  shopScore: string;
  distance: Distance;
  deliveryInfo: DeliveryInfo;
  logoUrl: string;
  openingTimeInfo: OpeningTimeInfo;
  contactInfo: ContactInfo;
  shopActivityList: ShopActivityItem[];
  brandPicUrl: string;
  finalDeliveryFee: Price;
  poiNewUserCouponInfo: PoiNewUserCouponInfo;
  lateCompensationLabel: LateCompensationLabel;
  recommendInfoList: RecommendInfo[];
  anotherOrderModule?: AnotherOrderModule;
  banner?: string;
  bannerV2?: BannerV2;
  scoreInfo?: ScoreInfo;
  pickupInfo: PickupInfo;
  locationInfo: LocationInfo;
  shopDisplayInfo: ShopDisplayInfo;
  userGetMode: UserGetMode;
  reviewsScoreModule?: ReviewsModule;
  titleText: string;
  titleImg: string;
  subTitleText: string;
  extra: any;
  favorite: Favorite;
  shopFeatureLabel?: shopFeatureItem[];
  /** 门店头部营销标签位 */
  shopTitlePromotionInfo?: ShopTitlePromotionInfo;
  /** 券包搭售 */
  shopCouponInfo?: ShopCouponInfo;
  shopWarnInfo?: ShopWarnInfo;
  expInfoList: ExpInfo[];
  shopShareInfo?: shopShareInfo;
  shopDetailInfo: ShopDetailInfo;
  shopAbnormalInfo?: ShopAbnormalInfo;//  门店异常信息 (包含门店超配信息)
  dietaryInfo?: DietaryInfo;
}

/**
 * 饮食信息
 */
export interface DietaryInfo {
  title: string;
  details: DietaryInfoItem[];
}

export interface DietaryInfoItem {
  icon: string;
  content: string;
}

/**
 * AbnormalType 表示异常类型，整数值。
 * - 1: 真正超配，超出商户的配送范围
 * - 2: 缩减范围超配：爆单导致的暂时超配
 */
type AbnormalType = 1 | 2;
export interface ShopAbnormalInfo {
  abnormalType: AbnormalType; // 枚举类型，异常类型
  abnormalText: string; // String类型，异常文案
}

export interface ExpInfo {
  id: number;
  groupId: number;
  expKey: string;
  groupKey: string;
  groupName: string;
}

// 商品橱窗
export interface ShopWindowInfo {
  windowStyle: string;
  productList: Spu[];
  title: string;
}

export interface ShopCouponInfo {
  entranceLeftText: string;
  entranceRightText: string;
  hasCoupon: string;
  productId: string;
  shopRegion: string;
  shopCityId: string;
  entranceStyle: {
    entranceLeftTextColor: string;
    highlightColor: string;
    entranceRightTextColor: string;
    backgroundImage: string;
    couponImage: string;
    arrowIcon: string;
    url: string;
  };
}

export interface ShopTitlePromotionInfo {
  /** 1:代表图片 2:代表文字+icon */
  displayType: string;
  title: string;
  icon: string;
  textColor: string;
  bgColor: string;
  picUrl: string;
}

export interface ShopLabel {
  style: number; // 0: 图片 1：动态标签
  labelType: string; //金牌店铺：shop_golden timeout：tag_timeout 米其林：tag_michelin
  tag: IDynamicTagGroup;
  picInfo: {
    picUrl: string;
  };
  link?: string;
  logData?: any;
}

interface Favorite {
  valid: number;
}

interface PickupLabel {
  /** 1-自取更优惠、2-自取堂食价、3-自取更省时 4-自取更优惠（门店活动）5-自取更优惠（模糊表达） */
  pickupLabelType: number;
  pickupLabelInfo: string;
}
interface PickupInfo {
  pickupTimeDesc: string; // 自提预计时间
  supportPickup: number; // 是否支持自提
  navigationType: number; // 导航方式
  pickupLabel: PickupLabel; // 自取引流标签气泡
  pickupLabelList: PickupLabel[]; // 自取引流标签列表
}

interface ShopDisplayInfo {
  showUserGetMode: number;
  scoreInfo: ScoreInfo;
  shopScoreInfo: ShopScoreInfo;
  reviewsScoreModule: ReviewsModule;
  showSearch: number; // 1:展示 0:不展示 搜索icon
  showPrimaryCategory: number; // 1:展示 0:不展示 搜索icon
  showContact?: number; // 1:展示 0:不展示 商家电话-门店详情页
  showShare: 1; //1:展示 0:不展示 分享标识
  showUnavailable?: ShowUnavailable; // 0:门店正常 1:超出配送范围 2:置休
  showDeliveryMode: number; // 1 展示起送价
}

export enum ShowUnavailable {
  NORMAL = 0, // 门店正常
  OUT_OF_RANGE = 1, // 超出配送范围
  CLOSE = 2, // 置休
}

interface ShopScoreInfo {
  icon: string;
  score: string;
}

interface shopShareInfo {
  type: string; //分享类型
  title: string; //分享卡片标题
  desc: string; //分享卡片描述
  shareImg: string; //分享主图
  shareLink: string; //拼接utm参数的分享链接
  defaultShareImg: string; //分享图片兜底图
}

export interface ReviewsModule {
  icon: string;
  reviewsScore: number;
  reviewsCntText: string;
  url: String;
  aiSummary: string;
  aiIcon: string;
}
export interface ScoreInfo {
  starText: string;
  starLogo: string;
  starDesc: string;
  starPage: StarPage;
}

export interface StarPage {
  starWords: string;
  starContentList: StarItem[];
}

export interface StarItem {
  logo: string;
  title: string;
  content: string;
}

export interface Banner {
  carousel: boolean; // 轮播开关
  carouselTime: number; // 轮播时长
  id: number; // 资源位Id
  activityList: BannerItem[]; // 轮播数据
}

export interface BannerV2 {
  channelId: string;
  autoPlay: boolean;
  carouselTime: number; // 轮播时长
  launchTaskList: any[];
  comp: any;
  launchTaskShowState: number;
}

export interface BannerItem {
  imgUrl: string; // 图片地址
  jumpUrl: string; // 跳转地址
  activityName: string; // 活动名称
  activityId: number; // 活动Id
  _hasLxReport: boolean; // 是否曝光
}

export interface AnotherOrderModule {
  title: string;
  orderViewId: string;
  productCountDesc: string;
  finishTimeDesc: string;
  buttonText: string;
  skuChooseDesc?: string;
  products?: SkuItem[];
}
export interface LateCompensationLabel {
  title: string;
  subTitle: string;
  url: string;
}
export interface PoiNewUserCouponInfo {
  title: string;
  couponId?: string;
  mainCategory: number;
  activityText: string;
  sillAmount: Price;
  counponAmount: Price;
}

export interface ShopActivityItem {
  actId: number;
  activityShowInfo: string;
  activityType: number;
  activityTitle: string;
  activityIcon: string;
  limitPrice: Price;
  limitPriceList: Price[];
  introduction: Introduction;
  backgroundUrl: string;
  backgroundUrlTop?: string;
  backgroundUrlBtm?: string;
  textColor: string;
  activityIconV2: string;
  arrowIcon?: string;
  bgColor: string;
}

/** 门店活动介绍 */
export interface Introduction {
  /** 弹层名称 */
  title: string;
  /** 优惠图标（区分折扣菜和门店优惠 */
  promotionIcon: string;
  /** 活动标题 */
  activityTitle: string;
  /** 活动标题第二行 */
  activityShowInfo: string;
  /** 活动有效期 */
  activityPeriod: string;
  /** 规则标题 */
  ruleTitle: string;
  /** 具体规则 */
  ruleDetails: string[];
}
export interface SectionItem {
  key: string;
  data: Array<ListItem>;
  index: number;
  sectionData: Category;
  context: AdapterContext;
  hasFoldSpu: boolean;
  foldSpuExpandStatus: boolean;
  isFoldSroll: boolean;
  categoryFoldSpuIdList: number[];
}

export interface ListFoodItem {
  key: string;
  data: Array<Spu>;
}

export interface SpuItem {
  data: Spu[];
}

export interface ListItem {
  key: string;
  type: number;
  data: Spu[];
  context: AdapterContext;
  sectionItem: SectionItem;
  indexPath: {
    item: number;
    section: number;
  };
  isLast: boolean;
  productListIndex: number;
}

export interface OpeningTimeInfo {
  currentOpeningDesc: string;
  openingRanges: string[];
  leftSecondsTillClose?: any;
  restTime: string;
  nextOpenTime: string | null;
}

export interface ContactInfo {
  website?: any;
  phoneList: string[];
}

export interface Distance {
  desc: string;
  number: string;
  unit: string;
  inDeliveryArea?: boolean;
}

export interface DeliveryMessageItem {
  icon: string;
  title: string;
  content: string;
}
export interface DeliveryMessageInfo {
  title: string;
  detailList: DeliveryMessageItem[];
}

export interface DeliveryInfo {
  deliveryDesc: string;
  deliveryType: number;
  deliveryMessageInfo: DeliveryMessageInfo;
  deliveryFee: Price;
  deliveryTime: string;
  deliveryTimeDesc: string;
  deliveryMode: number;
}
export interface ActivityInfo {

}
export interface LocationInfo {
  address: string;
  latitude: string;
  longitude: string;
  shopRegion: string;
}

// 门店购物车入参 https://km.sankuai.com/collabpage/1504955963
export interface Location {
  latitude: number;
  longitude: number;
  actualLatitude: number;
  actualLongitude: number;
}

export interface ShopProductGroupSku {
  groupSkuId: number;
  name: string;
  spuId: number;
  currency: string;
  discountPrice: number;
  originPrice: Price;
}

export interface ShopProductGroup {
  groupId: number;
  shopProductGroupSkuList: ShopProductGroupSku[];
}

export interface Product {
  skuId: number;
  name: string;
  picUrl: string;
  discountPrice: number;
  originPrice: number;
  spuId: number;
  count: number;
  currency: string;
  remark: string;
  spec: string;
  skuChooseDesc: string;
  sellTimeStatus: number;
  shopProductGroupList: ShopProductGroup[];
}

// 门店购物车出参根节点
export interface CalculateIn {
  location: Location;
  shopId: string;
  shippingMinPrice: number;
  shippingFee: number;
  productList: Product[];
}

export interface addItemActivityTypeItem {
  type: number;
  amount: number;
}

// 门店购物车出参
export interface CalculateOut {
  canSettle: number;
  totalCount: number;
  activityTips: string;
  minCostPriceTips: string;
  overLimit: number;
  overLimitTips: string;
  shopAvailable: number;
  shopUnAvailableTips: string;
  alcoholInfo: {
    hasAlcohol: number;
    alcoholTips: string;
    confirmText: string;
    cancelText: string;
  };
  mustChoiceInfo: {
    needMustChoice: number;
    shopCategoryId: number;
  };
  addItemData?: {
    addItemFlag: number;
    addItemButtonText: string;
  };
  addItemActivityTypeList?: addItemActivityTypeItem[];
  originDeliverFee: Price;
  discountDeliverFee: Price;
  hasProductUnavailable: number;
  productUnavailableTips: string;
  originPrice: Price;
  discountPrice: Price;
  skuList: SkuItem[] | [];
  logData: {
    margin_min_price: string;
    discount_information: string;
    shop_id: string;
  };
  expInfo?: {
    supportI18nDeliveryChange: number;
  };
  /** 切tab场景，购物车商品变更，拦截弹窗提示文案*/
  productUnavailableAlertTip: string;
  noSingleInfo: {
    onlyHasSingle: number;
    noSingleText: string;
  };
}

export interface activityTipItem {
  itemTip: string;
  itemTipType: number;
  iconUrl?: string;
  subTip?: string;
  themeColor?: string;
  backgroundColor?: string;
}
// 购物车价格计算接口返回值
export interface CalculatePrice {
  code: number;
  message: string;
  data: CalculateOut;
}
export interface GoodDetailParam {
  shopId: string;
  spuId: number;
  requestSource: number;
  latitude?: string;
  longitude?: string;
  productIndex?: number; //购物车浮层index
}

export interface GoodDetailResponse {
  code: number;
  msg: string;
  data: GoodDetailData;
  traceId?: any;
  success: boolean;
}

export interface GoodDetailData {
  spuId: number;
  name: string;
  chooseSkuId?: number;
  extraInfo?: SpuExtraInfo;
  aroundLabel?: AroundLabel;
  description: string;
  pictures: string[];
  minPrice: Price;
  discountPrice?: any;
  status?: any;
  skuList: Sku[];
  recommendInfoList?: any;
  activityInfoList: ActivityInfoItem[];
  hideRemark?: number; // 是否显示备注入口
  promotionTags?: PromotionTags[];
  couponTips?: CouponTips; //进店优惠提示
  firstCategoryId?: number; //当前商品所在的分类ID
  sameShopSpuData?: SameShopSpuData; //同店推荐
  /** 一口价浮层门店入口 */
  shopEntranceInfo?: ShopEntranceInfo;
  toastInfo?: {
    toastType: number;
    toastText: string;
  };
}

export interface ShopEntranceInfo {
  shopId: string;
  entranceText: string;
  spuId: number;
  categoryId: number;
}
export interface CouponTips {
  canUserCoupon?: number;
  couponText?: string;
  shopLink?: string;
}

export interface ActivityInfoList {
  activityType: number;
  amount: number;
  currency: string;
  extraInfo: ActivityExtraInfo;
}

export interface ActivityExtraInfo {
  limitCount: string;
  /** 新人折扣菜限购数量 */
  shopNewUserLimitCount?: number;
  /** 普通折扣菜限购数量 */
  normalDiscountLimitCount?: number;
}

export interface ExtraInfo {
  expInfoList: ExpInfoList[];
}

export interface ExpInfoList {
  id: number;
  groupId: number;
  groupKey: string;
  groupName: string;
  expKey: string;
  param: Param;
}

interface Param {
}
export interface AroundLabel {
  bgColor: string;
  icon: string;
  activityTitle: string;
  limitText: string;
}

export interface GoodDetailSkuList {
  skuId: number;
  skuSpec: string;
  name: string;
  calorie: string;
  originPrice: GoodDetailMinPrice;
  discountPrice: GoodDetailMinPrice;
  groupList: GoodDetailGroupList[];
  promotionTags: PromotionTags[];
  extraInfo: GoodDetailSkuExtraInfo;
  activityInfoList: ActivityInfoItem[];
  fullDiscountExtraInfo: FullDiscountExtraInfo;
  discountPriceList: DiscountPriceItem[];
  aroundLabel?: AroundLabel;
  promotionTagInfo?: {
    discountTag?: PromotionTag;
    windowDiscountTags?: PromotionTag;
    discountTypeTag?: PromotionTag;
  };
}

export interface DiscountPriceItem {
  promotionTags: PromotionTags[];
  discountPrice: GoodDetailMinPrice;
  sillAmount: Price;
  promotionTagInfo?: {
    discountTag?: PromotionTag;
    windowDiscountTags?: PromotionTag;
    discountTypeTag?: PromotionTag;
  };
}

export interface SelectedSkuList {
  skuId: number;
  skuSpec: string;
  originPrice: GoodDetailMinPrice;
  discountPrice: GoodDetailMinPrice;
  groupList: SelectedSkuGroupList[];
  promotionTags: PromotionTags[];
  extraInfo: GoodDetailSkuExtraInfo;
  activityInfoList: ActivityInfoItem[];
  fullDiscountExtraInfo: FullDiscountExtraInfo;
}

export interface FullDiscountExtraInfo {
  isMeetSillAmount: number;
  fullDiscountTips: string;
  fullDiscountToast: string;
  fullDiscountTipsIconFront: string;
  fullDiscountTipsIconLast: string;
  sillAmount?: Price;
}
export interface GoodDetailSkuExtraInfo {
  logData: {
    popular_option?: string;
  };
  nutritionInfo: NutritionAllergenDataTypes;
  allergiesInfo: NutritionAllergenDataTypes;
  hotTagInfo: HotTagInfo;
  burnoutDurationInfo: NutritionAllergenDataTypes;
  caffeineInfo: NutritionAllergenDataTypes;
  sodiumInfo: NutritionAllergenDataTypes;
}

// 商品橱窗折扣标签样式
interface WindowDiscountTag {
  text: string;
  color: string;
  icon: string;
  bgColor: string;
}
export interface PromotionTags {
  discountTag: IDynamicTagGroup;
  ruleTag: IDynamicTagGroup;
  windowDiscountTag?: WindowDiscountTag;
}

export interface GoodDetailGroupList {
  groupId: number;
  groupName: string;
  minNumber: number;
  maxNumber: number;
  status?: any;
  groupSkuList: GoodDetailGroupSku[];
  repeatable: number; //选项组是否可以复选
}

export interface SelectedSkuGroupList {
  groupId: number;
  groupName: string;
  minNumber: number;
  maxNumber: number;
  status?: any;
  groupSkuList: SelectedGroupSkuList[];
  repeatable: number; //选项组是否可以复选
}

export interface GoodDetailGroupSku {
  groupSkuId: number;
  spuId: number;
  name: string;
  calorie: string;
  originPrice: GoodDetailMinPrice;
  discountPrice: GoodDetailMinPrice;
  extraInfo: GoodDetailSkuExtraInfo;
  count: number;
}

export interface SelectedGroupSkuList {
  groupSkuId: number;
  spuId: number;
  name: string;
  calorie: string;
  originPrice: GoodDetailMinPrice;
  discountPrice: GoodDetailMinPrice;
  count: number;
  addIcon: string;
  status?: number;
  discountPriceList: DiscountPriceItem[];
  extraInfo: GoodDetailSkuExtraInfo;
}

export interface GoodDetailMinPrice {
  displayAmount: string;
  currency: string;
  displayText: string;
  amount: number;
}

export interface SelectedGroupSkuItem {
  groupSkuId: number;
  name: string;
  count: number;
}

export interface GroupSku {
  groupSkuId: number;
  spuId: number;
  name: string;
  count: number;
}

export interface GroupItem {
  groupId: number;
  groupSkuList: GroupSku[];
}

export interface SkuItem {
  skuId: number;
  name: string;
  picture: string;
  originPrice: Price;
  discountPrice: Price;
  spuId: number;
  count: number;
  remark: string;
  skuSpec: string;
  labels: PromotionTags[];
  sellTimeStatus: number;
  skuChooseDesc: string;
  discountProduct: number;
  groupList: GroupItem[];
}

export interface DefaultGoodDetail {
  skuId: number;
  channelCode?: number;
  soldOutType?: number;
  discountPrice?: number;
  name: string;
  picture: string;
  originPrice: GoodDetailMinPrice;
  spuId: number;
  count: number;
  remark: string;
  skuSpec: string;
  groupList: DefaultGroupList[];
}

export interface DefaultGroupList {
  groupId: number;
  groupSkuList: DefaultGroupSkuList[];
}

export interface DefaultGroupSkuList {
  groupSkuId: number;
  spuId: number;
  name: string;
  count: number;
}

export interface RichTextItem {
  type: string;
  text?: string;
  color?: string;
  fontSize?: number;
  fontFamily?: string;
  fontWeight?: string;
  width?: number;
}

export interface AdapterContext {
  foodListRef: any;
  highlightCategoryId: number | string;
  adapter: any;
}

export interface ShopCategoryItem {
  shopCategoryId: number;
  spuIdList: number[];
}

export interface ItemBinder {
  type: string | number;
  requireSpuCount: number;
}

// 营养成分/过敏源
// 枚举类型 Nutrition Allergen
export enum BasicNutritionAllergenTypeEnum {
  Nutrition = 'nutrition',
  Allergen = 'allergen',
}
export enum NutritionAllergenTypeEnum {
  Nutrition = 'nutrition',
  Allergen = 'allergen',
  Calorie = 'calorie'
}
export interface NutritionAllergenDataTypes {
  title: string;
  icon: string;
  valueList: [{
    name: string;
    value?: string;
  }];
}
export interface NutritionAllergenType {
  source?: number;
  shop_id: string;
  sku_id: number;
  spu_id: number;
  spu_property_type: string;
}

export interface HotTagInfo {
  icon: string;
  title: string;
}

export interface ActivityTipsBar {
  type: string;
  buttonText: string;
  trackInfo: {
    pickUpSaveMoney: number;
    pickUpSaveShippingFee: number;
  };
}

// 购物车v1/order/preview接口-低消弹窗信息类型
export interface AreaItem {
  areaType: number; // 1: 到店自取, 2: 外卖配送
  title: string;
  subTitle: string;
  labelText: string;
  iconUrl: string;
  buttonText: string; // 按钮文案
}

export interface AlertInfo {
  message: string;
  duration: number;
  minOrderPopType: number; // 0: 导流场景, 1: 非导流场景
  title: string;
  subTitle: string;
  areaList: AreaItem[];
}

// 低消弹窗 埋点类型
export interface BaseTrackingParams {
  shop_id: string;
}

export interface NonDiversionParams extends BaseTrackingParams {
  button_name: number;
}
